/**
 * Import from node_modules
 */
import 'bootstrap/js/src/scrollspy';

/**
 * Import site scripts
 */
import SkipLinkFocusFix from './site/skip-link-focus-fix';
import Menu from './site/menu';
import Sliders from './site/sliders';
import ScrollTo from './site/scrollTo';
import Styleguide from './site/styleguide';
// import Fancybox from './site/fancybox';
import Select2 from './site/select2';
import FormHelpers from './site/formHelpers';
import PerfectScroll from './site/perfectScroll';
import LazyLoading from './site/lazyLoad';
// import LoadMoreBlog from './site/loadMoreBlog';
import Header from './site/header';
import Counter from './site/counter';
import EqualHeights from './site/equalHeights';
import Popups from './site/popups';
import FormLabel from './site/formLabel';
import Accordion from './site/accordion';
import FAQ from './site/faq';
import Animations from './site/animations';
import SingleProduct from './site/singleProduct';
import Register from './site/register';
import Tabs from './site/tabs';
import Cart from './site/cartPage';
import MyAccount from './site/myAccount';
import Checkout from './site/checkout';
import LocationAutocompleteBilling from './site/LocationAutocompleteBilling';
import LocationAutocompleteShipping from './site/LocationAutocompleteShipping';
import CustomOrder from './site/customOrder';
import Video from './site/video';
import CheckoutFormPersistence from './site/checkoutFormPersistence';

/**
 * Init site scripts
 */
jQuery(function() {
	SkipLinkFocusFix.init();
	Styleguide.init();
	Menu.init();
	Sliders.init();
	ScrollTo.init();
	// Fancybox.init();
	Select2.init();
	FormHelpers.init();
	PerfectScroll.init();
	LazyLoading.init();
	// LoadMoreBlog.init();
	Header.init();
	Counter.init();
	EqualHeights.init();
	Popups.init();
	FormLabel.init();
	Accordion.init();
	FAQ.init();
	Animations.init();
	SingleProduct.init();
	Register.init();
	Tabs.init();
	Cart.init();
	MyAccount.init();
	Checkout.init();
	LocationAutocompleteBilling.initAutocomplete();
	LocationAutocompleteShipping.initAutocomplete();
	CustomOrder.init();
	Video.init();
	CheckoutFormPersistence.init();
});
